import React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { ManualImportForm } from '../useManualImport';
import { ActionBar } from './ActionBar';
import { ExpensesSection } from './ExpensesSection';
import { MetaSection } from './MetaSection';
import { ProductLinesSection } from './ProductLinesSection';
import { SummaryPanel } from './SummaryPanel';

type ManualImportViewProps = {
    form: ManualImportForm;
};

/** Render-only orchestrator: stacks the manual-import sections in order. */
export const ManualImportView: React.FC<ManualImportViewProps> = ({ form }) => (
    <div
        className="flex flex-col gap-6"
        {...getNodeTestIdProp('manual-import')}
    >
        <MetaSection form={form} />
        <ProductLinesSection form={form} />
        <ExpensesSection form={form} />
        <SummaryPanel form={form} />
        <ActionBar form={form} />
    </div>
);
